// src/pages/Login.jsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../components/PageContainer';

function Login() {
  const { login, loginWithGoogle, currentUser } = useAuth();
  const navigate = useNavigate();

  // State for toggling the email login form
  const [isEmailLogin, setIsEmailLogin] = useState(false);

  // Form fields
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Handle email login
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      alert('Login successful!');
      navigate('/account');
    } catch (error) {
      console.error('Login error:', error);
      alert(error.message);
    }
  };

  // Handle Google login
  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
      alert('Google login successful!');
      navigate('/account');
    } catch (error) {
      console.error('Google login error:', error);
      alert(error.message);
    }
  };

  // If user is already logged in, no need to login again
  if (currentUser) {
    return (
      <div className="page login-page">
        <h2>You're already logged in!</h2>
        <button className="submit-button" onClick={() => navigate('/account')}>
          Go to Account
        </button>
      </div>
    );
  }

  return (
    <PageContainer>
      <h2>Login</h2>
      <p>Please choose a login method below.</p>

      <div className="button-container">
        <button
          className="submit-button"
          onClick={() => setIsEmailLogin(!isEmailLogin)}
        >
          {isEmailLogin ? 'Cancel' : 'Login with Email'}
        </button>

        <button className="submit-button" onClick={handleGoogleLogin}>
          Login with Google
        </button>
      </div>

      <div className={`dropdown-form ${isEmailLogin ? 'open' : ''}`}>
        {isEmailLogin && (
          <>
            <p>Please enter your email and password to log in.</p>
            <form onSubmit={handleEmailLogin} className="music-form">
              <label className="form-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <label className="form-label">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button className="submit-button" type="submit">
                Login (Email/Pass)
              </button>
            </form>
          </>
        )}
      </div>
    </PageContainer>
  );
}

export default Login;
